import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Slider } from '@material-ui/core';
import _ from 'lodash';
import classNames from 'classnames';
import { isMobileOnly, isTablet, isPortrait } from 'react-device-detect';

import './SportsFilters.scss';
import { marks } from '../../../utils/content';
import { select } from '../../../configs/store';
import Icon from '../../Icon/Icon';
import Tree from './Tree/Tree';
import Search from '../../Filter/Search/Search';
import Button from '../../Button/Button';
import BetCodeSearch from 'src/components/BetCodeSearch/BetCodeSearch';
import AppModeContext from '../../../containers/AppMode/AppMode.context';

class SportsFilters extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      selectedMarks: marks[this.getSliderMarks('')]
    };
  }

  async componentDidMount() {
    const {
      match,
      location,
      filterSports,
      changeFilterSportsType,
      changeFilterSportsHours,
      changeFilterSportsTournaments,
      getSportEvents,
      getSportEventsTree
    } = this.props;

    let type = '1,8';
    if (match.params.type === 'outright') {
      type = '4';
    } else if (match.params.type === 'live') {
      type = '2,8';
    }

    const query = new URLSearchParams(location.search);
    if (type !== filterSports.type) {
      const newMarks = marks[this.getSliderMarks(type)];
      await changeFilterSportsType({ type, ...newMarks[0] });
    }

    if (query.get('range')) {
      const rangeHours = Number(query.get('range'));
      const mark = _.find(this.state.selectedMarks, m => m.hours === rangeHours);

      if (mark) {
        await changeFilterSportsHours({ range: mark.value, rangeHours });
      }
    }

    if (query.get('tournaments')) {
      await changeFilterSportsTournaments({
        checked: true,
        tournaments: query.get('tournaments').split(',')
      });
    }

    if (isMobileOnly || (isTablet && isPortrait)) {
      await getSportEventsTree();
    } else {
      await getSportEvents();
    }
  }

  async componentDidUpdate(prevProps) {
    const {
      match,
      filterSports,
      changeFilterSportsType,
      getSportEvents
    } = this.props;

    if (prevProps.match.params.type !== match.params.type) {
      if (!prevProps.match.params.type && match.params.type === 'prematch') {
        return;
      }

      let type = '1,8';

      if (match.params.type === 'outright') {
        type = '4';
      } else if (match.params.type === 'live') {
        type = '2,8';
      }

      if (type !== filterSports.type) {

        const newMarks = marks[this.getSliderMarks(type)];
        await changeFilterSportsType({ type, ...newMarks[0] });
        this.setState({
          ...this.state,
          selectedMarks: newMarks
        });
        await getSportEvents();
      }
    }
  }

  getSliderMarks = (type) => {
    switch (type) {
      case '2,8':
        return 'live';

      case '4':
        return 'outright';

      default:
        return 'prematch';
    }
  }

  changeFilterType = (type) => async (event) => {
    event.preventDefault();

    const {
      filterSports,
      changeFilterSportsType,
      getSportEventsTree,
      getSportEventsList
    } = this.props;

    if (type !== filterSports.type) {
      await this.resetFilters(event);
      const newMarks = marks[this.getSliderMarks(type)];

      this.setState({ selectedMarks: newMarks });

      if (type === '4') {
        await changeFilterSportsType({ type, ...newMarks[4] });
      } else {
        await changeFilterSportsType({ type, ...newMarks[0] });
      }

      await getSportEventsTree();
      if (!(isMobileOnly || (isTablet && isPortrait))) {
        await getSportEventsList();
      }
    }
  }

  changeFilterSportsHours = async (event, value) => {
    event.preventDefault();

    const {
      history,
      location,
      changeFilterSportsHours,
      getSportEventsTree
    } = this.props;

    history.replace({
      pathname: location.pathname,
      search: `?range=${ this.state.selectedMarks[value - 1].hours }`
    });
    await changeFilterSportsHours({ range: value, rangeHours: this.state.selectedMarks[value - 1].hours });
    await getSportEventsTree();
  }

  resetFilters = async (event) => {
    event.preventDefault();

    const { resetFilterSports, location, history, setInitialFilterSports } = this.props;
    const type = '1,8';
    const newMarks = marks[this.getSliderMarks(type)];

    this.setState({ selectedMarks: newMarks });
    await this.props.changeFilterSportsType({ type, ...newMarks[0] });
    await resetFilterSports(!(isMobileOnly || (isTablet && isPortrait))); // True if desktop, false if mobile
    await setInitialFilterSports();
    history.replace({
      pathname: location.pathname
    });

    window.scrollTo(0, 300);
  }

  resetSearch = () => {
    this.props.resetSearchResults();
  }

  getSearchResults = (value) => {
    this.props.clearFilterTournaments();
    this.props.getSearchResults({ q: value, product: 'sports' });
  }

  handleCollapse = () => {
    const { RETAIL_MODE } = this.context;

    this.props.changeSidebarCollapsed({ sidebar: 'leftSideBar', isRetail: RETAIL_MODE, width: window.innerWidth });
  }

  showBin = () => {
    const { filterSports } = this.props;
    return filterSports.range !== 1 || filterSports.type !== '1,8' || filterSports.tournaments.length > 0;
  };

  render() {
    const { t, treeLoading, filterSports, total } = this.props;
    const { selectedMarks } = this.state;

    return (
      <div className="tree">
        <div className="tree__header">
          {
            !(isMobileOnly || (isTablet && isPortrait)) &&
            <button onClick={ this.handleCollapse } className="tree__btn--cross">
              <Icon icon="minimize" />
            </button>
          }
          <Search
            placeholder={ t('filterSports.searchPlaceholder')  }
            searchHelper={ t('filterSports.searchHelper')  }
            getSearchResults={ this.getSearchResults }
            handleReset={ this.resetSearch }
            minLength={ 3 }
          />
        </div>
        <BetCodeSearch productType={ 1 } />

        { !(isMobileOnly || (isTablet && isPortrait)) && <Tree quickLinks /> }

        <div className="tree__title">
          <span>{ t('filterSports.title') }</span>

          { this.showBin() && <Icon className="tree__icon" icon="trash" onClick={ this.resetFilters } /> }
        </div>

        <div className="tree__buttons">
          <Button
            onClick={ this.changeFilterType('2,8') }
            className={
              classNames({
                'tree__btn': true,
                'tree__btn--active': filterSports.type === '2,8',
                'btn--outlined':true
              })
            }
            text={ t('filterSports.inPlay') }
          />
          <Button
            onClick={ this.changeFilterType('1,8') }
            className={
              classNames({
                'tree__btn': true,
                'tree__btn--active': filterSports.type === '1,8',
                'btn--outlined':true
              })
            }
            text={ t('filterSports.upcoming') }
          />
          { /* TODO: needed for a later time when prematch & outright and separated again */ }
          { /* <Button
            onClick={ this.changeFilterType('4') }
            className={
              classNames({
                'tree__btn': true,
                'tree__btn--active': filterSports.type === '4',
                'btn--outlined':true
              })
            }
            text={ t('filterSports.outrights') }
          /> */ }

        </div>

        <div className="tree__slider">
          <Slider
            valueLabelDisplay="off"
            step={ 1 }
            min={ 1 }
            max={ selectedMarks.length }
            marks={ selectedMarks }
            value={ filterSports.range }
            disabled={ treeLoading }
            onChange={ this.changeFilterSportsHours }
          />
        </div>

        <Tree />

        {
          total > 0 && <div className="tree__mobile-button">
            <Button
              onClick={ () => this.props.getFilterResults(this.props.filterSports.tournaments) }
              className="btn--primary tree__submit"
              text={ `${ t('filterSports.seeResults', { total }) }` }
            />
            {
              <Button
                onClick={ this.resetFilters }
                className="tree__clear"
                text={ t('filterSports.clearFilters') }
              />
            }
          </div>
        }
      </div>
    );
  }
}

SportsFilters.propTypes = {
  t: PropTypes.func,
  changeFilterSportsType: PropTypes.func,
  changeFilterSportsHours: PropTypes.func,
  filters: PropTypes.object,
  filterSports: PropTypes.object,
  resetFilterSports: PropTypes.func,
  treeLoading: PropTypes.bool,
  isSearching: PropTypes.bool,
  match: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
  changeFilterSportsTournaments: PropTypes.func,
  getSportEvents: PropTypes.func,
  getSportEventsTree: PropTypes.func,
  getSportEventsList: PropTypes.func,
  getSearchResults: PropTypes.func,
  pageRef: PropTypes.object,
  clearFilterTournaments: PropTypes.func,
  resetSearchResults: PropTypes.func,
  getFilterResults: PropTypes.func,
  eventsTree: PropTypes.array,
  total: PropTypes.number,
  changeSidebarCollapsed: PropTypes.func,
  setInitialFilterSports: PropTypes.func
};

const selection = select(state => ({
  total: state.filters.total
}));

const mapState = state => ({
  filterSports: state.events.filterSports,
  treeLoading: state.events.treeLoading,
  isSearching: state.events.isSearching,
  eventsTree: state.events.eventsTree,
  ...selection(state)
});

const mapDispatch = dispatch => ({
  changeFilterSportsType: (type) => dispatch.events.changeFilterSportsType(type),
  changeFilterSportsHours: (obj) => dispatch.events.changeFilterSportsHours(obj),
  resetFilterSports: (value) => dispatch.events.resetFilterSports(value),
  getSportEventsTree: () => dispatch.events.getSportEventsTree(),
  getSportEventsList: () => dispatch.events.getSportEventsList(),
  getSportEvents: () => dispatch.events.getSportEvents(),
  changeFilterSportsTournaments: (obj) => dispatch.events.changeFilterSportsTournaments(obj),
  getSearchResults: (value) => dispatch.events.getSearchResults(value),
  clearFilterTournaments: () => dispatch.events.clearFilterTournaments(),
  resetSearchResults: () => dispatch.events.resetSearchResults(),
  getFilterResults: (value) => dispatch.filters.getFilterResults(value),
  changeSidebarCollapsed: (sidebar) => dispatch.content.changeSidebarCollapsed(sidebar),
  setInitialFilterSports: () => dispatch.events.setInitialFilterSports()
});

SportsFilters.contextType = AppModeContext;

export default withRouter(connect(mapState, mapDispatch)(withTranslation('common')(SportsFilters)));

